import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme: any) => ({
  filterContainer: {
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    '&:focus': {
      outline: 'none',
      border: 'none',
    },
  },
  popOverContents: {
    width: 400,
  },
  title: {
    display: 'flex',
    alignItems: 'center',
  },
  icon: {
    marginRight: 10,
    display: 'inline-block',
  },
  container: {
    width: 350,
    height: 'calc(80vh - 262px)',
    maxHeight: '600px',
  },
  listItem: {
    padding: 0,
  },
  listItemText: {
    padding: theme.spacing(0.5),
    paddingRight: theme.spacing(2),
    paddingLeft: theme.spacing(2),
    width: '100%',
    '& .MuiTypography-displayBlock': {
      display: 'unset',
    },
  },
  smallButton: {
    fontSize: '0.65rem',
    padding: '1px 7px',
    marginRight: theme.spacing(1),
  },
  input: {
    display: 'flex',
    flexDirection: 'row-reverse',
    paddingRight: theme.spacing(1),
    paddingLeft: theme.spacing(1),
    paddingTop: theme.spacing(0.5),
    paddingBottom: theme.spacing(0.5),
    background: theme.palette.grey[100],
  },
  button: {
    color: theme.palette.primary.contrastText,
    width: '100%',
    margin: theme.spacing(1),
  },
  menuTitle: {
    color: '#43485C',
    fontFamily: 'lato-light',
    textTransform: 'uppercase',
  },
}));

export default useStyles;
